import { getApiActionTypes } from '../storeHelpers';

export const fetchGenericSourceDataTypes = getApiActionTypes('FETCH_GENERIC_SOURCE_DATA');
